export var AuthorizeErrorCode;
(function (AuthorizeErrorCode) {
    AuthorizeErrorCode["Apm"] = "error.authorize.requiresApmAuthorization";
    AuthorizeErrorCode["ThreeDs"] = "error.authorize.requires3DSecure";
})(AuthorizeErrorCode || (AuthorizeErrorCode = {}));
//# sourceMappingURL=error-extensions.js.map